module.exports = __webpack_public_path__ + "img/icon_contact_04.254b5d0.svg";